import { FirstPromoterProvider } from './../providers/first-promoter/first-promoter';
import { UserProvider } from './../providers/user/user';
import { Observable } from 'rxjs/Observable';
import { AuthProvider } from './../providers/auth/auth';
import { MainPage, TutorialPage } from './../pages/pages';
import { Component, ViewChild } from '@angular/core';
import { Nav, Platform, LoadingController } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { SignalsProvider } from '../providers/signals/signals';
import { PwaProvider } from '../providers/pwa/pwa';
import { FcmProvider } from '../providers/fcm/fcm';
import { IntercomProvider } from '../providers/intercom/intercom';

@Component({
  templateUrl: 'app.html',

})
export class MyApp {
  rootPage:any = null;
  hasAccess: Observable<boolean>;
  isAdmin: Observable<boolean>;
  @ViewChild(Nav) nav: Nav;

  dashboardPage = { title: 'Dashboard', component: 'DashboardPage'};
  portfolioPage = { title: 'Portfolio', component: 'PortfolioPage'};
  watchlistPage = { title: 'Watchlist', component: 'WatchlistPage'};

  coinsPage = { title: 'Coins', component: 'CoinsPage'};
  newsPage = { title: 'News', component: 'NewsPage'};
  guidesPage = { title: 'Guides', component: 'GuidesPage'};
  glossaryPage = { title: 'Glossary', component: 'GlossaryPage'};
  pulsePage = { title: 'Pulse', component: 'PulsePage'};

  loginPage = { title: 'Login', component: 'LoginPage'};
  settingsPage = { title: 'Settings', component: 'UserSettingsPage'};

  userAdmin = { title: 'Users', component: 'UsersPage'};

  showCryptoCurrencyTools = false;
  showBlocktisticsAcademy = false;
  showUserProfile = false;

  constructor(
    platform: Platform,
    statusBar: StatusBar,
    splashScreen: SplashScreen,
    public auth: AuthProvider,
    public signalCtrl: SignalsProvider,
    public user: UserProvider,
    public signals: SignalsProvider,
    private pwa: PwaProvider,
    private promoter: FirstPromoterProvider,
    private fcm: FcmProvider,
    private loadingCtrl: LoadingController,
    public intercom: IntercomProvider
    )
  {

    this.hasAccess = this.user.hasAccess();
    this.isAdmin = this.user.isAdmin();

    let loader = this.loadingCtrl.create();
    loader.present();
    platform.ready().then(() => {
      statusBar.styleLightContent();
      this.auth.isAuthenticated.first().subscribe(authed => {
        if(!this.nav.last()){ //check if we are at root
          if(authed) this.rootPage = MainPage; 
          else this.rootPage = TutorialPage
        }
        splashScreen.hide();
        loader.dismiss();
      }, error =>{
        loader.dismiss();
      });
    });
  }

  ngOnInit(){
    // this.pwa.alertPWA();
  }

  openPage(page) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    this.nav.setRoot(page.component, page.params);
  }

  pushPage(page) {
    this.nav.push(page.component)
  }

  openReferralProgram(){
    this.promoter.goToPromoter();
  }

  goToPrime(service: string, type: string){
    this.nav.setRoot('prime', {service, type: type || ''});
  }
}




// WEBPACK FOOTER //
// ./src/app/app.component.ts